
import api from "@/services/api"
import { ViewFullSummary } from "@/types/views/viewSummary"
import { View } from "@/types/views/view"

interface ViewsRequestDetails {
	viewId: string | null;
	searchTerm: string;
	cacheId: string;
}

export class ViewsService {
	public viewSummary: ViewFullSummary | null = null;
	public loading: boolean = false;

	public viewError: any = null;
	public tenantId: string | null = null;
	public activeViewId: string | null = null;
	public activeView: View | null = null;

	private viewLoadPromise: Promise<ViewFullSummary> | null = null
	private requestedViewDetails: ViewsRequestDetails | null = null

	public async loadViews (searchTerm: string = "", cacheId: string = "") {
		const thisRequestViewDetails = {
			viewId: this.activeViewId,
			searchTerm: searchTerm,
			cacheId: cacheId
		}

		if (this.viewLoadPromise &&
			this.requestedViewDetails?.viewId === thisRequestViewDetails.viewId &&
			this.requestedViewDetails.searchTerm === thisRequestViewDetails.searchTerm &&
			this.requestedViewDetails.cacheId === thisRequestViewDetails.cacheId) {
			await this.viewLoadPromise
			return
		}

		try {
			this.loading = true
			this.viewError = null

			this.requestedViewDetails = thisRequestViewDetails
			this.viewLoadPromise = api.caseViews(this.activeViewId, searchTerm, cacheId)
			this.viewSummary = await this.viewLoadPromise
			this.activeView = this.viewSummary!.activeView

			if (this.activeView) {
				this.activeViewId = this.activeView.id
			}
		} catch (err) {
			this.viewError = err
		} finally {
			this.viewLoadPromise = null
			this.requestedViewDetails = null
		}

		this.loading = false
	}

	public reset () {
		this.viewSummary = null
		this.activeView = null
		this.tenantId = null
		this.activeViewId = null
		this.viewLoadPromise = null
		this.requestedViewDetails = null
	}
}

const viewsService = new ViewsService()
export default viewsService
